import { Action, createReducer, on } from "@ngrx/store";
import * as MessageHubActions from '../../../../state/actions/message-hub.actions';
import * as DataImportActions from '../state/actions/data-import-logs.actions';

export interface DataImportLogData {
    message: string;
    inputFileName: string;
    provisioningType: string;
    logType: string;
    hangfireJobId: number;
};

export interface DataImportLogState {
    logs: DataImportLogData[]
};

const initialDataImportLogState: DataImportLogState =
{
    logs: []
};

const reducer = createReducer<DataImportLogState>(
    initialDataImportLogState,

    on(MessageHubActions.receivedProvisionLogData,
        (dataImportLogState, action): DataImportLogState => ({
            logs: dataImportLogState.logs.concat(action.messageData ? JSON.parse(action.messageData) : [])
        })),

    on(DataImportActions.clearProvisionLogData,
        (dataImportLogState, action): DataImportLogState => ({
            logs: action.state
        }))
);

export function dataImportLogStateReducer(state: DataImportLogState | undefined, action: Action) {
    return reducer(state, action);
}
